<template>
  <Modal name="CREATE_EDIT_CATEGORY_MODAL" :title="title" actions>
    <template v-slot:body>
      <v-form ref="categoryForm" v-model="valid" lazy-validation>
        <v-text-field
          v-model="name"
          @keydown.enter.prevent="validate"
          :label="$t('category.label.name')"
          :loading="isCategoryLoading"
          :rules="rules.required"
          ref="categoryNameInput"
          hide-details="auto"
          outlined
        />
      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isCategoryLoading"
        elevation="0"
        class="mr-5"
        large
      >
        {{ $t('category.action.cancel') }}
      </v-btn>

      <v-btn
        @click="validate"
        :loading="isCategoryLoading"
        color="primary"
        elevation="0"
        large
      >
        {{
          category ? $t('category.action.edit') : $t('category.action.create')
        }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { required } from '@/util/defaultValidationRules'

import Modal from '@/components/app/Modal'

export default {
  name: 'CategoryCreateEdit',

  components: {
    Modal,
  },

  data() {
    return {
      id: null,
      name: null,
      valid: false,
      rules: {
        required,
      },
    }
  },

  watch: {
    category(category) {
      Promise.resolve(category)
        .then(() => {
          const currentId = category?.id

          if (currentId) this.fillCategoryFields()
          else this.resetCategoryFields()
        })
        .then(() => {
          return this.$refs?.categoryNameInput?.$el?.querySelector('input')
        })
        .then((input) => input?.focus())
    },
  },

  computed: {
    ...mapGetters(['isCategoryLoading', 'category']),

    title() {
      return this.isCategoryLoading
        ? this.$t('category.action.loading')
        : this.category
        ? this.$t('category.action.edit')
        : this.$t('category.action.create')
    },
  },

  methods: {
    ...mapActions(['createEditCategory']),
    ...mapMutations(['closeAllModals']),

    validate() {
      if (this.$refs.categoryForm.validate()) {
        const category = {
          id: this.id ? this.id : null,
          name: this.name,
        }

        this.createEditCategory(category)
      }
    },

    fillCategoryFields() {
      this.id = this.category ? this.category.id : null
      this.name = this.category ? this.category.name : null
    },

    resetCategoryFields() {
      this.id = null
      this.name = null

      this.$nextTick(() => {
        this.$refs.categoryForm && this.$refs.categoryForm.resetValidation()
      })
    },
  },
}
</script>
